import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "time-out-flag"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 6 }

import { reactive, computed, ref, onMounted, toRaw } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import BusinessName from '@/components/BusinessName/index.vue'
import ChannelText from '@/components/CosCascaderText/components/channel.vue'
import CustomerAreaCascader from '@/components/CustomerAreaCascader/index.vue'
import ParamCodeCascader from '@/components/CosCascader/components/ParamCodeCascader.vue'
import Modal from '@/hooks/modalType'
import {
  businessStatusEnum,
  clueAndcustomerPhaseEnum,
  remanentBusinessDayTypeEnum
} from '@/views/yuntuSales/commonEnum/dataConfig'
import { listByParamCodes } from '@/api/common'
import { customerListFormat } from '@/utils'
import type { ParamCodeItem } from '@/typings/common'
import { businessList, businessDelete, businessDetails, businessMultipleDelete } from '@/api/yuntuSales/chanceManage'
import { BusinessParams, BusinessListItem } from '@/typings/api/chanceManage'
import formatThousandSeparator from '@/utils/format'
import ImportBtn from '@/components/ImportBtn'
import { LbuSalesClueListItem } from '@/typings/api/clueManage'
import { salesClueDelete } from '@/api/yuntuSales/clueManage'

const __default__ = { name: 'DcCosLbuBusiness' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const router = useRouter()
const route = useRoute()

const statusEnum = businessStatusEnum.map((item) => ({
  name: item.label,
  value: item.value,
  color: item.color
}))
// 时间类型枚举
const timeTypeEnum = [
  { label: '创建时间', value: 0 },
  { label: '跟进时间', value: 1 },
  { label: '更新时间', value: 2 }
]
const paramCodeData = ref<{
  lbu_demand_country: ParamCodeItem[]
  lbu_products: ParamCodeItem[]
  lbu_logistics_service_provider: ParamCodeItem[]
  lbu_sales_category: ParamCodeItem[]
}>({
  lbu_demand_country: [], // 目的地国家
  lbu_products: [], // 出货渠道（云途产品）
  lbu_logistics_service_provider: [], // 物流服务商
  lbu_sales_category: []
})
// 获取业务参数
const getByParamCodes = () => {
  listByParamCodes({
    appId: 'cos_lbu',
    paramCodes: ['lbu_demand_country', 'lbu_products', 'lbu_logistics_service_provider', 'lbu_sales_category']
  }).then((res) => {
    paramCodeData.value = res.data
  })
}
onMounted(() => {
  getByParamCodes()
})
const tableRef = ref()
const queryForm = reactive<BusinessParams>({ dataType: 'all', timeType: 0 })
const columns = computed(() => [
  { title: '商机名称', dataIndex: 'saleChanceName', fixed: 'left', width: 150 },
  { title: '客户代码', dataIndex: 'tmsCode' },
  { title: '客户名称', dataIndex: 'customerName', width: 200 },
  { title: '客户阶段', dataIndex: 'stage', dicData: clueAndcustomerPhaseEnum },
  { title: '客户标签', dataIndex: 'biCustomerStatus' },
  { title: '主账号代码', dataIndex: 'customerNumber' },
  { title: '客户ID', dataIndex: 'saleChanceRefId', width: 200 },
  { title: '商机ID', dataIndex: 'id', width: 200 },
  { title: '联系人姓名', dataIndex: 'contactName', cosType: 'mask' },
  { title: '手机号', dataIndex: 'contactMobile', cosType: 'mask' },
  { title: '目的地国家', dataIndex: 'requiredCountry', dicData: paramCodeData.value.lbu_demand_country },
  { title: '云途产品', dataIndex: 'product', width: 150 },
  { title: '客户归属区域', dataIndex: 'warehouseAttribution' },
  { title: 'OPR金额', dataIndex: 'planSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OPR票数', dataIndex: 'mau', type: 'money', sorter: true },
  { title: 'OCR金额', dataIndex: 'committedSaleAmount', type: 'money', width: 200, sorter: true },
  { title: 'OCR票数', dataIndex: 'committedShipment', type: 'money', sorter: true },
  { title: 'OPR重量', dataIndex: 'oprWeight', type: 'money', sorter: true },
  { title: 'OCR重量', dataIndex: 'ocrWeight', type: 'money', sorter: true },
  { title: 'OPR方数', dataIndex: 'oprCube', type: 'money', sorter: true },
  { title: 'OCR方数', dataIndex: 'ocrCube', type: 'money', sorter: true },
  { title: '发货频次', dataIndex: 'shipmentFrequency', type: 'money', sorter: true },
  { title: '货物品类', dataIndex: 'goodsCategory', dicData: paramCodeData.value.lbu_sales_category },
  { title: '商机状态', dataIndex: 'status', width: 300 },
  { title: '竞争对手', dataIndex: 'competitors' },
  { title: '客户负责人', dataIndex: 'dutyByName' },
  { title: '备注', dataIndex: 'remark' },
  { title: '剩余变更时间', dataIndex: 'remanentFollowDays', width: 200, sorter: true },
  { title: '最新跟进时间', dataIndex: 'latestFollowTime', width: 190, sorter: true },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 190, sorter: true },
  { title: '更新人', dataIndex: 'updateByName' },
  { title: '更新时间', dataIndex: 'updateTime', width: 190, sorter: true },
  { title: '操作', dataIndex: 'action', width: 180, fixed: 'right' }
])
const getList = (queryForm: BusinessParams, callBack: (res: any) => void) => {
  const params = customerListFormat(queryForm) // 处理客户名称和客户编码的批量查询参数

  const saleChanceRefId = params.saleChanceRefId
  if (saleChanceRefId !== undefined && saleChanceRefId.length > 0) {
    params.saleChanceRefIdList = saleChanceRefId.split(' ')
    params.saleChanceRefId = undefined
  }

  businessList(params).then((res) => {
    callBack(res)
  })
}
const selectedData = ref<BusinessListItem[]>([])
const onSelectRowsChange = (selectedRowKeys: string[], selectedRows: BusinessListItem[]) => {
  selectedData.value = selectedRows
}
const showMask = (record: BusinessListItem, callBack: (res: any) => void) => {
  businessDetails({ id: record.id }).then((res) => {
    callBack(res.data)
  })
}

const handleTabsChange = (val: any) => {
  queryForm.dataType = val
  if (val === 'me' && queryForm.dutyBy) {
    queryForm.dutyBy = undefined
  }
  tableRef.value?.search()
}
// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: '/lbu/business/edit', query: { id } })
  } else {
    router.push('/lbu/business/add')
  }
}
// 跳转写跟进页面
const handleWriteFollowUp = (row: BusinessListItem) => {
  const { id: chanceId, saleChanceRefId: cosId, customerStatus } = row
  if (customerStatus == null) return false
  // 公海池的数据
  if (customerStatus === 0) {
    return message.warning('该线索已经流转到公海池')
  }
  router.push({
    path: '/lbu/followUpRecord/add',
    query: { followRefId: cosId as string, chanceId, returnPath: route.fullPath }
  })
}
const handleQueryChange = (type?: 'search' | 'fetch') => {
  if (type === 'search') {
    tableRef.value?.search()
  } else {
    tableRef.value?.fetch()
  }
}
// const handleDelete = (row: BusinessListItem) => {
//   Modal.delete({
//     name: row.saleChanceNameByTxt,
//     onOk() {
//       businessDelete({ id: row.id }).then(() => {
//         message.success('删除商机成功')
//         tableRef.value?.delFetch()
//       })
//     }
//   })
// }
const handleDelete = (row?: BusinessListItem) => {
  if (!row && !selectedData.value?.length) {
    return message.error('请选择要删除的数据')
  }
  const idList: any[] = []
  const chanceName = []
  if (row) {
    idList.push(row.id)
    chanceName.push(row.saleChanceNameByTxt)
  } else {
    selectedData.value?.forEach((item) => {
      idList.push(item.id)
      chanceName.push(item.saleChanceNameByTxt)
    })
  }
  Modal.delete({
    name: chanceName.join(','),
    onOk() {
      businessMultipleDelete({ idList }).then(() => {
        message.success('删除商机成功')
        tableRef.value?.fetch()
        deleteRefresh(0)
      })
    }
  })
}
const deleteRefresh = (num: number) => {
  const params = toRaw(selectedData.value)
  params.splice(0, num)
  tableRef.value?.delFetch(params, 'clueId')
}
// 判断跳转客户或者线索详情页
const triggerCustomer = (row: BusinessListItem) => {
  const { customerStatus, saleChanceRefId } = row
  if (customerStatus == null) {
    return false
  } else if (customerStatus === 0) {
    // 公海池的数据
    return message.warning('该线索已经流转到公海池')
  } else if (customerStatus === 1 || customerStatus === 3) {
    // 正常线索的数据
    router.push({ path: '/lbu/salesClue/view', query: { clueId: saleChanceRefId as string } })
  } else if (customerStatus >= 10 && customerStatus <= 14) {
    // 潜在客户的数据
    router.push({ path: '/lbu/potential/view', query: { cosId: saleChanceRefId as string } })
  } else if (customerStatus >= 30 && customerStatus <= 39) {
    // 成交客户的数据
    router.push({ path: '/lbu/clients/view', query: { cosId: saleChanceRefId as string } })
  } else {
    return false
  }
}
/**
 * 竞争对手序列化
 * @param arr 对手数组
 */
const competitorFormat = (arr: any) => {
  if (!Array.isArray(arr) || !arr?.length) return '--'
  const listEnum = paramCodeData.value.lbu_logistics_service_provider
  const result: string[] = []
  arr.forEach((ele) => {
    const item = listEnum.find((e) => e.id === ele)
    if (item) result.push(item.name as string)
  })
  return result.join('、')
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_UserSelect = _resolveComponent("UserSelect")!
  const _component_ParamCodesSelect = _resolveComponent("ParamCodesSelect")!
  const _component_CosRangePicker = _resolveComponent("CosRangePicker")!
  const _component_a_input_group = _resolveComponent("a-input-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_ExportButton = _resolveComponent("ExportButton")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_dc_status = _resolveComponent("dc-status")!
  const _component_SellerButton = _resolveComponent("SellerButton")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, { "is-breadcrumb": true }, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: queryForm.dataType,
            "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.dataType) = $event)),
            onChange: handleTabsChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "all",
                tab: "全部"
              }),
              _createVNode(_component_a_tab_pane, {
                key: "me",
                tab: "我的商机"
              }),
              _createVNode(_component_a_tab_pane, {
                key: "subUser",
                tab: "下属商机"
              })
            ]),
            _: 1
          }, 8, ["activeKey"]),
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            search: queryForm,
            "onUpdate:search": _cache[22] || (_cache[22] = ($event: any) => ((queryForm) = $event)),
            "row-selection": { onChange: onSelectRowsChange },
            onFetch: getList,
            onMask: showMask,
            ref_key: "tableRef",
            ref: tableRef,
            rowKey: "id",
            tableId: "business_table"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "customerName",
                    label: "客户名称",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.customerName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.customerName) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入客户名称"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "tmsCode",
                    label: "客户代码",
                    span: 12
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_textarea, {
                        value: queryForm.tmsCode,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.tmsCode) = $event)),
                        autoSize: { minRows: 1, maxRows: 4 },
                        placeholder: "请输入客户代码"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "customerNumber",
                    label: "主账号代码"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.customerNumber,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.customerNumber) = $event)),
                        maxlength: 200,
                        allowClear: "",
                        placeholder: "请输入主账号代码"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "status",
                    label: "商机状态"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.statusList,
                        "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.statusList) = $event)),
                        options: _unref(businessStatusEnum),
                        placeholder: "请选择商机状态",
                        allowClear: "",
                        mode: "multiple"
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  (queryForm.dataType !== 'me')
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 0,
                        name: "dutyBy",
                        label: "客户负责人"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_UserSelect, {
                            permission: "",
                            value: queryForm.dutyByList,
                            "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((queryForm.dutyByList) = $event)),
                            placeholder: "请选择客户负责人",
                            mode: "multiple",
                            allowClear: ""
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_dc_form_item, {
                    name: "contactMobile",
                    label: "手机号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.contactMobile,
                        "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.contactMobile) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 100,
                        allowClear: "",
                        placeholder: "请输入手机号"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (queryForm.dataType !== 'me')
                    ? (_openBlock(), _createBlock(_component_dc_form_item, {
                        key: 1,
                        name: "customerAreaIdList",
                        label: "客户区域"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(CustomerAreaCascader, {
                            type: "search",
                            appId: "cos_lbu",
                            ids: queryForm.customerAreaIdList,
                            "onUpdate:ids": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.customerAreaIdList) = $event)),
                            placeholder: "请选择客户区域"
                          }, null, 8, ["ids"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_dc_form_item, { label: "员工区域" }, {
                    default: _withCtx(() => [
                      _createVNode(CustomerAreaCascader, {
                        type: "search",
                        appId: "cos_lbu",
                        ids: queryForm.employeeRegionList,
                        "onUpdate:ids": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.employeeRegionList) = $event))
                      }, null, 8, ["ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "requiredCountry",
                    label: "目的地国家"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ParamCodesSelect, {
                        value: queryForm.requiredCountryList,
                        "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.requiredCountryList) = $event)),
                        options: paramCodeData.value.lbu_demand_country,
                        placeholder: "请选择目的地国家",
                        mode: "multiple",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "product",
                    label: "云途产品"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ParamCodeCascader, {
                        type: "search",
                        ids: queryForm.productList,
                        "onUpdate:ids": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.productList) = $event)),
                        options: paramCodeData.value.lbu_products,
                        placeholder: "请选择云途产品",
                        multiple: "",
                        allowClear: ""
                      }, null, 8, ["ids", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "product",
                    label: "竞争对手"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(ParamCodeCascader, {
                        value: queryForm.competitors,
                        "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((queryForm.competitors) = $event)),
                        options: paramCodeData.value.lbu_logistics_service_provider,
                        placeholder: "请选择竞争对手",
                        allowClear: ""
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "timeType",
                    label: "时间筛选"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input_group, { compact: "" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_select, {
                            value: queryForm.timeType,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((queryForm.timeType) = $event)),
                            options: timeTypeEnum,
                            style: {"width":"33%"}
                          }, null, 8, ["value"]),
                          _createVNode(_component_CosRangePicker, {
                            startTime: queryForm.startTime,
                            "onUpdate:startTime": _cache[13] || (_cache[13] = ($event: any) => ((queryForm.startTime) = $event)),
                            endTime: queryForm.endTime,
                            "onUpdate:endTime": _cache[14] || (_cache[14] = ($event: any) => ((queryForm.endTime) = $event)),
                            style: {"width":"67%"}
                          }, null, 8, ["startTime", "endTime"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "saleChanceRefId",
                    label: "客户ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.saleChanceRefId,
                        "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((queryForm.saleChanceRefId) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入客户ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "id",
                    label: "商机ID"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.id,
                        "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((queryForm.id) = $event)),
                        maxlength: 500,
                        allowClear: "",
                        placeholder: "请输入商机ID"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, { label: "剩余变更时间" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.remanentFollowDayType,
                        "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((queryForm.remanentFollowDayType) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: _unref(remanentBusinessDayTypeEnum)
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "remark",
                    label: "备注"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.remark,
                        "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((queryForm.remark) = $event)),
                        valueModifiers: { trim: true },
                        maxlength: 1000,
                        allowClear: "",
                        placeholder: "请输入备注"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[19] || (_cache[19] = ($event: any) => (triggerAddOrEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_business_add_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_unref(ImportBtn), {
                action: "/lbu/api/saleChance/import",
                templateUrl: "/lbu/api/saleChance/template/download",
                onSuccess: _cache[20] || (_cache[20] = ($event: any) => (handleQueryChange('search')))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导入 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_business_import_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_ExportButton, {
                appId: "cos_lbu",
                taskType: "305",
                search: _unref(customerListFormat)(queryForm)
              }, {
                default: _withCtx(() => [
                  _createTextVNode("导出 ")
                ]),
                _: 1
              }, 8, ["search"])), [
                [_directive_permission, 'lbu_business_export_btn']
              ]),
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                danger: "",
                onClick: _cache[21] || (_cache[21] = ($event: any) => (handleDelete()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("删除 ")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_business_del_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record, text }) => [
              (column.dataIndex === 'saleChanceName')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 0,
                    to: { path: '/lbu/business/view', query: { id: record.id } }
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_1, [
                        (record.timeoutFlag === true)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_2, "超时"))
                          : _createCommentVNode("", true),
                        text
                          ? (_openBlock(), _createBlock(BusinessName, {
                              key: 1,
                              appId: "cos_lbu",
                              value: record.saleChanceName,
                              "onUpdate:value": ($event: any) => ((record.saleChanceName) = $event),
                              label: record.saleChanceNameByTxt,
                              "onUpdate:label": ($event: any) => ((record.saleChanceNameByTxt) = $event)
                            }, null, 8, ["value", "onUpdate:value", "label", "onUpdate:label"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                              _createTextVNode("--")
                            ], 64))
                      ])
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'customerName')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    text
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 0,
                          href: "javascript:;",
                          onClick: ($event: any) => (triggerCustomer(record))
                        }, _toDisplayString(text), 9, _hoisted_3))
                      : (_openBlock(), _createElementBlock("span", _hoisted_4, "--"))
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'product')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 2,
                    appId: "cos_lbu",
                    paramCode: "lbu_products",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'warehouseAttribution')
                ? (_openBlock(), _createBlock(ChannelText, {
                    key: 3,
                    appId: "cos_lbu",
                    paramCode: "lbu_warehouse_city",
                    value: text
                  }, null, 8, ["value"]))
                : _createCommentVNode("", true),
              (column.dataIndex === 'competitors')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                    _createTextVNode(_toDisplayString(competitorFormat(text) || '--'), 1)
                  ], 64))
                : _createCommentVNode("", true),
              (column.dataIndex === 'status')
                ? (_openBlock(), _createBlock(_component_dc_status, {
                    key: 5,
                    enums: _unref(statusEnum),
                    value: text
                  }, null, 8, ["enums", "value"]))
                : _createCommentVNode("", true),
              (column.type === 'money')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_unref(formatThousandSeparator)(text)), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleWriteFollowUp(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("写跟进")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'lbu_business_write_follow_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_SellerButton, {
                      type: "link",
                      disabled: record.status===7,
                      onClick: ($event: any) => (triggerAddOrEdit(record.id))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("编辑")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])), [
                      [_directive_permission, 'lbu_business_edit_btn']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                      type: "link",
                      onClick: ($event: any) => (handleDelete(record))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("删除")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])), [
                      [_directive_permission, 'lbu_business_del_btn']
                    ])
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search", "row-selection"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})